import React from "react";

const DocumentsSection = ({ documents = [] }) => {
  console.log("Documents received from parent:", documents);
  return (
    <div className="insurance-card">

      <h3>Insurance Documents</h3>

      {documents.length === 0 ? (
        <p>No documents found.</p>
      ) : (
        <table className="documents-table">

          <thead>
            <tr>
              <th>Document</th>
              <th>Status</th>
              {/* <th>Required</th>
              <th>Auto Fetch</th> */}
              {/* <th>Uploaded By</th> */}
              <th>Uploaded At</th>
              <th>Action</th>
            </tr>
          </thead>

          <tbody>

            {documents.map((doc) => (

              <tr key={doc._id}>

                <td>{doc.name}</td>

                <td>

                  {doc.uploaded ? (
                    <span className="uploaded">
                      Uploaded
                    </span>
                  ) : (
                    <span className="pending">
                      Pending
                    </span>
                  )}

                </td>

                {/* <td>

                  {doc.required ? "Yes" : "No"}

                </td>

                <td>

                  {doc.auto_fetch ? "Yes" : "No"}

                </td>

                <td>

                  {doc.uploaded_by?.name || "-"}

                </td> */}

                <td>

                  {doc.uploaded_at
                    ? new Date(doc.uploaded_at).toLocaleString()
                    : "-"}

                </td>

                <td>
                  {doc.file_url ? (
                    <a
                      href={doc.file_url}
                      target="_blank"
                      rel="noreferrer"
                      className="view-btn"
                    >
                      View
                    </a>
                  ) : (
                    <span className="no-file">Not Uploaded</span>
                  )}
                </td>

              </tr>

            ))}

          </tbody>

        </table>
      )}

    </div>
  );
};

export default DocumentsSection;